export var isCustomOption = function(maybeCustomOption) {
    return "onValueChange" in maybeCustomOption;
};
export var getLabel = function(option) {
    return option.label;
};
export var getValue = function(option) {
    return option.value;
};
var getModularIndex = function(index, maxValue) {
    return (index % maxValue + maxValue) % maxValue;
};
/**
 * Get the next non-disabled index
 */ export var getNextIndex = function(eventKey, options, highlightIndex) {
    var optionsCount = options.length;
    var nextIndex = highlightIndex;
    for(var i = 0; i < optionsCount; ++i){
        nextIndex = nextIndex + (eventKey === "ArrowDown" ? 1 : -1);
        nextIndex = getModularIndex(nextIndex, optionsCount);
        var nextOption = options[nextIndex];
        if (nextOption && !nextOption.disabled) {
            return nextIndex;
        }
    }
    // we've iterated over all possibilities, let's keep the same option
    return highlightIndex;
};
